import { CategoryData } from '../../../../types/types';

export const nombres: CategoryData = {
    // Nombres de base (1-10)
    'Oua': {
        translation: 'Un',
        translationEn: 'One',
        illustration: '1️⃣',
        audio: 'Co-Oua'
    },
    'Snau': {
        translation: 'Deux',
        translationEn: 'Two',
        illustration: '2️⃣',
        audio: 'Co-Snau'
    },
    'Slomt': {
        translation: 'Trois',
        translationEn: 'Three',
        illustration: '3️⃣',
        audio: 'Co-Slomt'
    },
    'Ftou': {
        translation: 'Quatre',
        translationEn: 'Four',
        illustration: '4️⃣',
        audio: 'Co-Ftou'
    },
    'Tiou': {
        translation: 'Cinq',
        translationEn: 'Five',
        illustration: '5️⃣',
        audio: 'Co-Tiou'
    },
    'Soou': {
        translation: 'Six',
        translationEn: 'Six',
        illustration: '6️⃣',
        audio: 'Co-Soou'
    },
    'Saf': {
        translation: 'Sept',
        translationEn: 'Seven',
        illustration: '7️⃣'
    },
    'Etmoun': {
        translation: 'Huit',
        translationEn: 'Eight',
        illustration: '8️⃣',
        audio: 'Co-Etmoun'
    },
    'Psou': {
        translation: 'Neuf',
        translationEn: 'Nine',
        illustration: '9️⃣',
        audio: 'Co-Psou'
    },
    'Metou': {
        translation: 'Dix',
        translationEn: 'Ten',
        illustration: '🔟',
        audio: 'Co-Metou'
    },
    // Dizaines (11-90)
    'Mntoua': {
        translation: 'Onze',
        translationEn: 'Eleven',
        illustration: '1️⃣1️⃣'
    },
    'ǧout': {
        translation: 'Vingt',
        translationEn: 'Twenty',
        illustration: '2️⃣0️⃣'
    },
    'Maab': {
        translation: 'Trente',
        translationEn: 'Thirty',
        illustration: '3️⃣0️⃣'
    },
    'Hme': {
        translation: 'Quarante',
        translationEn: 'Forty',
        illustration: '4️⃣0️⃣'
    },
    'Taiou': {
        translation: 'Cinquante',
        translationEn: 'Fifty',
        illustration: '5️⃣0️⃣'
    },
    'Se': {
        translation: 'Soixante',
        translationEn: 'Sixty',
        illustration: '6️⃣0️⃣'
    },
    'Šfe': {
        translation: 'Soixante-dix',
        translationEn: 'Seventy',
        illustration: '7️⃣0️⃣'
    },
    'Hmene': {
        translation: 'Quatre-vingts',
        translationEn: 'Eighty',
        illustration: '8️⃣0️⃣'
    },
    'Pstaiou': {
        translation: 'Quatre-vingt-dix',
        translationEn: 'Ninety',
        illustration: '9️⃣0️⃣'
    },
    // Centaines (100-900)
    'Še': {
        translation: 'Cent',
        translationEn: 'One hundred',
        illustration: '💯'
    },
    'Šet snau': {
        translation: 'Deux cents',
        translationEn: 'Two hundred',
        illustration: '2️⃣0️⃣0️⃣'
    },
    'Slomt nše': {
        translation: 'Trois cents',
        translationEn: 'Three hundred',
        illustration: '3️⃣0️⃣0️⃣'
    },
    'Ftou nše': {
        translation: 'Quatre cents',
        translationEn: 'Four hundred',
        illustration: '4️⃣0️⃣0️⃣'
    },
    'Tiou nše': {
        translation: 'Cinq cents',
        translationEn: 'Five hundred',
        illustration: '5️⃣0️⃣0️⃣'
    },
    // Mille
    'Šo': {
        translation: 'Mille',
        translationEn: 'One thousand',
        illustration: '1️⃣0️⃣0️⃣0️⃣'
    },
    // Nombres composés exemples
    'ǧout mn oua': {
        translation: 'Vingt-et-un',
        translationEn: 'Twenty-one',
        illustration: '2️⃣1️⃣'
    },
    'Še mn ǧout': {
        translation: 'Cent vingt',
        translationEn: 'One hundred twenty',
        illustration: '1️⃣2️⃣0️⃣'
    },
    'Še mn maab mn tiou': {
        translation: 'Cent trente-cinq',
        translationEn: 'One hundred thirty-five',
        illustration: '1️⃣3️⃣5️⃣'
    }
};

export default nombres;

export {};
